import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ResourceService, UserService, CalendarLanguagueService } from '@services/index.service';
import { I18n } from '@services/i18n/datepicker-i18n';
import { environment } from "@environments/environment";

@Component({
  selector: 'lang-selector',
  templateUrl: './lang-selector.component.html',
  styleUrls: ['./lang-selector.component.scss']
})
export class LangSelectorComponent implements OnInit {
  /** Lenguaje en el que se muestra el site */
  lang;

  constructor(public translate: TranslateService,
    public _resourceService: ResourceService,
    public _userService: UserService,
    public _i18n: I18n,
    public locale: CalendarLanguagueService) { }


  /** Cambiamos el idioma del site a la lengua que recibimos */
  changeLanguage(lang) {
    this.translate.use(lang);
    this._resourceService.language = lang;
    this.locale.changeLanguage(lang);
    this._i18n.language = lang;
  }

  ngOnInit() {

  }

}
